import { render, staticRenderFns } from "./inventoryManageDetail.vue?vue&type=template&id=65879c0e&scoped=true"
import script from "./inventoryManageDetail.vue?vue&type=script&lang=js"
export * from "./inventoryManageDetail.vue?vue&type=script&lang=js"
import style0 from "./inventoryManageDetail.vue?vue&type=style&index=0&id=65879c0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65879c0e",
  null
  
)

export default component.exports